"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
class Observer extends preact_1.Component {
    constructor() {
        super(...arguments);
        this.container = null;
    }
    componentDidMount() {
        this.io = new IntersectionObserver(([entry]) => {
            this.setState({ isVisible: entry.isIntersecting });
            const { onVisibleChange } = this.props;
            if (onVisibleChange)
                onVisibleChange(entry.isIntersecting);
        });
        this.io.observe(this.container);
    }
    componentWillUnmount() {
        if (this.io) {
            this.io.disconnect();
        }
    }
    render({ children, className }, { isVisible }) {
        const kids = Array.isArray(children) ? children : [children];
        return ((0, preact_1.h)("div", { ref: div => (this.container = div), className: className }, kids.map((child) => (child ? (0, preact_1.cloneElement)(child, { isVisible }) : null))));
    }
}
exports.default = Observer;
//# sourceMappingURL=observer.js.map